import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpRequestMethods,
  LoggingService
} from '@com-delta-idp/mnx-utils';
import { Observable, throwError } from 'rxjs';
import { SBW_TIMEOUT } from '../constants/common.constants';
import { EndpointKeys, IDP_APPS } from '../constants/urls.constants';
import { BookWidgetAemResponse } from '../models/core-apis/book-widget-aem.interfaces';

@Injectable({ providedIn: 'root' })
export class AemService {
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private logging: LoggingService
  ) {}

  getBookWidgetAem(): Observable<BookWidgetAemResponse> {
    return new ApiBuilder<string, BookWidgetAemResponse>(
      this.http,
      this.appConfig
    )
      .app(IDP_APPS.BOOK_WIDGET)
      .endpointKey(EndpointKeys.BOOK_WIDGET_AEM_URL)
      .method(HttpRequestMethods.GET)
      .errorHandler(this._handleError.bind(this))
      .timeOut(SBW_TIMEOUT.PE_AE)
      .create();
  }

  private _handleError(error: HttpErrorResponse): Observable<never> {
    this.logging.log(error.message);
    return throwError(error);
  }
}
